import React from 'react';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { compatWrapper } from '@backstage/core-compat-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

/**
 * Aba "Code Quality" com tabela de métricas SonarQube dos componentes filhos.
 * Aparece exclusivamente em entidades do tipo System.
 */
const sonarqubeOverviewContent = EntityContentBlueprint.make({
  name: 'sonarqube-overview',
  params: {
    path: '/code-quality',
    title: 'Code Quality',
    filter: (entity) => entity.kind.toLowerCase() === 'system',
    loader: async () => {
      const { SonarQubeRelatedEntitiesOverview } = await import(
        '@backstage-community/plugin-sonarqube'
      );
      return compatWrapper(
        React.createElement(SonarQubeRelatedEntitiesOverview, {
          relationType: 'hasPart',
          entityKind: 'component',
        }),
      );
    },
  },
});

export const sonarqubeOverviewPlugin = createFrontendPlugin({
  pluginId: 'sonarqube-overview',
  extensions: [sonarqubeOverviewContent],
});
